module.exports = __webpack_public_path__ + "img/rspca-act.841be64.png";